'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './vendor-show.routes';

export class VendorShowComponent {
  constructor($stateParams, VendorService, $uibModal, $window, RecentVisits, PinnedItems, WorkOrderTicketsService, SettingsService, CustomEntityService) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.vendorId = $stateParams.id;
    this.$uibModal = $uibModal;

    this.tasks = [];
    this.activities = [];
    this.custom = {};

    this.VendorService = VendorService;
    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;

    WorkOrderTicketsService.getByVendor({id: this.vendorId}, data => {
      let filteredData = data.filter(wo => wo.status == 'open');
      this.workOrders = filteredData.map(wo => {
        return {
          type: 'Work Order',
          name: wo.code + ": " + wo.name,
          date: wo.meta.creationDate,
          targetDate: wo.targetDate,
          url: "/workorder/ticket/detail/"+wo._id
        }
      });
    });

    SettingsService.getByName({name: 'custom-entities-views'}, settings => {
      this.customEntitiesConfig = settings.data.vendor || {display:[]};
      this.customEntitiesConfig.display.forEach(customType => {
        let typeConfig = this.customEntitiesConfig[customType];
        this.custom[customType] = CustomEntityService.getCustomList({type: customType, refField: typeConfig.refField, refId: $stateParams.id});
      });
    });

    this.refreshData();
  }

  refreshData() {
    if (this.vendorId) {
      this.VendorService.get({id: this.vendorId}, data => {
        this.vendor = data;

        this.RecentVisits.addPortfolio(this.vendorId, "vendor", this.vendor.name);
        this.isPinned = this.PinnedItems.isPinnedPortfolio(this.vendorId);
      }, err => {
        console.log('Could not load vendor from server');
      });
    }
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.VendorService.addAttachments({id: that.vendorId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to vendor');
        });
      },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduu.vendorShow', [uiRouter])
  .config(routes)
  .component('vendorShow', {
    template: require('./vendor-show.html'),
    controller: VendorShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/vendor-show/vendor-show.component.js